module.exports = __webpack_public_path__ + "static/images/hero.584218098770c1bad87a3709d2128ed7.jpg";